import { Check, CheckCircle, Public } from "@mui/icons-material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAddress } from "../../request/Fetchcurrentaddress";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import {
  BIBlue,
  BIGreen,
  BILightGreen,
  BILightRed,
  BILightYellow,
  BIRed,
  BIYellow
} from "../../assets/helpers";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import AddWebsiteModal from "../common/AddWebsiteModal";
import PictureViewer from "../common/PictureViewer";
import PromptModal from "../common/PromptModal";
import {
  DELETE_SITES,
  FETCH_SITES,
  FETCH_SITES_BY_COMPANY_AND_PRODUCT,
  FETCH_SITES_DESCRIPTIONS,
  FETCH_SITES_PROJECTS_PICTURES,
  SAVE_POST_PICTURE,
  SAVE_POSTS,
  SAVE_SITE_PRODUCTS,
  SAVE_SITE_COMPANIES,
  SAVE_SITES,
  SITE_ACTIVE,
  SITE_ISSUES
} from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import {
  setChoosesite,
  setNolocationcount,
  setNoLocationSites,
  setProjectimages,
  setSelectedsite,
  setSelectlocation,
  setShowaddproject,
  setShowmapmodal,
  setShowReport,
  setSiteprojects
} from "../../redux/actions/actions";
import { CompanyListSkeleton } from "../skeleton/SkeletonView";
import AddDescription from "./AddDescription";
import Addsitename from "./Addsitename";
import Sitedescriptions from "./Sitedescriptions";
import SiteImages from "./SiteImages";
import SitesCompanySection from "./SitesCompanySection";
import SitesProductSection from "./SitesProductSection";
import SitesProjectSection from "./SitesProjectSection";
import { useLocation, useParams } from "react-router-dom";
import SitesBuySellSection from "./SitesBuySellSection";
import SitesJobPostSection from "./SitesJobPostSection";
import SitesServicesSection from "./SitesServicesSection";

const SiteCard = (props) => {
  //1. Declaration of hooks
  const dispatch = useDispatch();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  //2. Get the data from redux
  const {
    loginData,
    selectedSite,
    showMapmodal,
    updateSiteprojects,
    selectLocation,
    multiLanguageData,
    showAddproject
  } = useSelector((state) => state?.main);

  const {
    TEXT_DROPPED_PIN = English?.SiteDetail?.TEXT_DROPPED_PIN,
    TEXT_ADD_NEW_SITE = English?.SiteDetail?.TEXT_ADD_NEW_SITE,
    TEXT_ADD_PROJECT_CAPS = English?.SiteDetail?.TEXT_ADD_PROJECT_CAPS,
    TEXT_NO_PROJECTS_AT_LOCATION = English?.SiteDetail?.TEXT_NO_PROJECTS_AT_LOCATION,
    TEXT_ACTIVE = English?.SiteDetail?.TEXT_ACTIVE,
    TEXT_ADD_DESCRIPTION_CAPS = English?.SiteDetail?.TEXT_ADD_DESCRIPTION_CAPS,
    TEXT_ADD_DESCRIPTION = English?.SiteDetail?.TEXT_ADD_DESCRIPTION,
    TEXT_REPORT = English?.SiteDetail?.TEXT_REPORT,
    TEXT_UNNAMED_SITE = English?.SiteDetail?.TEXT_UNNAMED_SITE,
    TEXT_FLAG_ACTIVE = English?.SiteDetail?.TEXT_FLAG_ACTIVE,
    TEXT_ADD_SITE_NAME_STATEMENT = English?.SiteDetail?.TEXT_ADD_SITE_NAME_STATEMENT,
    DESCRIPTION_SEE_MORE = English?.SiteDetail?.DESCRIPTION_SEE_MORE,
    TEXT_ADD_LOCATION = English?.SiteDetail?.TEXT_ADD_LOCATION,
    TEXT_DELETE_SITE = English?.SiteDetail?.TEXT_DELETE_SITE,
    TEXT_NO_LOCATION = English?.SiteDetail?.TEXT_NO_LOCATION,
    TEXT_SITE_NOT_VISIBLE_MESSAGE = English?.SiteDetail?.TEXT_SITE_NOT_VISIBLE_MESSAGE,
    TEXT_ADD_SITE_LOCATION = English?.SiteDetail?.TEXT_ADD_SITE_LOCATION,
    TEXT_ADD_SITE_NAME_CAPS = English?.SiteDetail?.TEXT_ADD_SITE_NAME_CAPS,
    TEXT_OTHERS_DESCRIPTIOJN = English?.SiteDetail?.TEXT_OTHERS_DESCRIPTIOJN,
    TEXT_CHOOSE = English?.SiteDetail?.TEXT_CHOOSE,
    BUTTON_DELETE = English?.SiteDetail?.BUTTON_DELETE,
    TEXT_DELETE_SITE_ALERT = English?.SiteDetail?.TEXT_DELETE_SITE_ALERT,
    TEXT_DELETE_SITE_DESC_ALERT = English?.SiteDetail?.TEXT_DELETE_SITE_DESC_ALERT,
    TEXT_COMPANIES = English?.SiteDetail?.TEXT_COMPANIES,
    TEXT_PRODUCTS = English?.SiteDetail?.TEXT_PRODUCTS,
    TEXT_PROJECTS = English?.SiteDetail?.TEXT_PROJECTS,
    TEXT_SERVICES = English?.SiteDetail?.TEXT_SERVICES,
    TEXT_JOB_POSTINGS = English?.SiteDetail?.TEXT_JOB_POSTINGS,
    BUTTON_ADD_WEBSITE = English?.SiteDetail?.BUTTON_ADD_WEBSITE,
    TEXT_ADD_PICTURE = English?.SiteDetail?.TEXT_ADD_PICTURE
  } = multiLanguageData?.SiteDetail || {};

  const { TEXT_ACTIVE_SITE = English?.AddSite?.TEXT_ACTIVE_SITE } =
    multiLanguageData?.AddSite || {};

  //3. Declaration of states
  const [loading, setLoading] = useState(false);
  const [siteDescriptions, setSiteDescriptions] = useState([]);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(false);
  const [projectImageArray, setProjectImageArray] = useState([]);
  const [addDescriptionDialogOpen, setAddDescriptionDialogOpen] = useState(false);
  const [addSiteWebsiteModalOpen, setAddSiteWebsiteModalOpen] = useState(false);
  const [otherDescriptionDialogOpen, setOtherDescriptionDialogOpen] = useState(false);
  const [desNum, setDesnum] = useState(0);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewIndex, setPictureViewIndex] = useState(0);
  const [showAddNameModal, setShowAddNameModal] = useState(false);
  const [initialViewMore, setInitialViewMore] = useState(true);
  const [siteInfo, setSiteInfo] = useState({});
  const [deleteSiteConfirmModalOpen, setDeleteSiteConfirmModalOpen] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [skipEffect, setSkipEffect] = useState(false);
  const [isSitePresent, setIsSiteIsPresent] = useState(false);
  const fileInputRef = useRef(null);
  const { id } = useParams();
  const location = useLocation();

  const validValues = [
    "experience",
    "company-detail",
    "product-detail",
    "manufacture-detail",
    "earn-rewards"
  ];
  const [activeTab, setActiveTab] = useState(
    validValues.includes(showMapmodal?.from) ? "projects" : ""
  );

  let scrollTargetId = "scrollablediv";

  const isSiteInfoIncomplete =
    siteInfo?.website === "" &&
    (siteInfo?.address !== "" || siteInfo?.latitude !== 0 || siteInfo?.longitude !== 0);

  const tabsOptions = validValues.includes(showMapmodal?.from)
    ? [
        {
          name: "projects",
          value: TEXT_PROJECTS
        }
      ]
    : [
        {
          name: "companies",
          value: TEXT_COMPANIES
        },
        {
          name: "projects",
          value: TEXT_PROJECTS
        },
        {
          name: "products",
          value: TEXT_PRODUCTS
        },
        {
          name: "job-postings",
          value: TEXT_JOB_POSTINGS || "Job Postings"
        },
        {
          name: "services",
          value: TEXT_SERVICES || "Services"
        },
        {
          name: "buy-sell",
          value: "BuySell"
        }
      ];

  useEffect(() => {
    if (skipEffect) {
      setSkipEffect(false);
      return;
    }
    const getInformation = async () => {
      await Promise.all([getSiteInfo(), getSiteImages(), fetchSitesByCompanyandProduct()]);
      if (props.showSiteCardModal === true && validValues.includes(showMapmodal?.from)) {
        setActiveTab("projects");
      } else {
        setActiveTab("companies");
      }
    };
    getInformation();
    return () => {
      setProjectImageArray([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showSiteCardModal, selectedSite]);

  // When we open unnamed site and when we add project site card will refresh
  useEffect(() => {
    if (showAddproject === false) {
      getSiteInfo();
    }
  }, [showAddproject]);

  useEffect(() => {
    if (location?.state?.site?.siteId) {
      // Set the site in redux store
      dispatch(
        setSelectedsite({
          ...location?.state?.site,
          id: location?.state?.site?.siteId // ensure id is set for API calls
        })
      );

      // Initialize site data
      const initSite = async () => {
        try {
          await Promise.all([getSiteInfo(), getSiteImages()]);
          // Show site card after data is loaded
          if (props.setShowSiteCardModal) {
            props.setShowSiteCardModal(true);
          }
          props?.setShowsitedetail(true);
        } catch (error) {
          console.error("Error initializing site:", error);
        }
      };

      initSite();
    }
  }, [location?.state?.site]);

  const getSiteInfo = async () => {
    try {
      setLoading(true);
      if (selectedSite?.id) {
        const payload = { FetchAllowedRecordsOnly: true, SearchList: [{ Id: selectedSite?.id }] };
        const siteResponse = await Postrequestcall(FETCH_SITES, payload, loginData?.accessToken);
        if (siteResponse.status === 200) {
          setSiteInfo(siteResponse?.data?.data[0] ?? {});
          if (siteResponse?.data?.data[0]?.siteDescription !== "") {
            setDesnum(siteResponse?.data?.data[0]?.nrOfDescriptions - 1);
            setSiteDescriptions([{ description: siteResponse?.data?.data[0]?.siteDescription }]);
          }
        }
      }
    } catch (error) {
      console.log("getSiteInfo-> Error While Fetching Site Info: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSitesByCompanyandProduct = async () => {
    if (showMapmodal?.select !== "add-site") return;
    if (showMapmodal?.from === "post-a-job") return;
    try {
      const isCompanyOrManufacturer =
        showMapmodal?.from === "company-detail" || showMapmodal?.from === "manufacture-detail";

      const payload = {
        SiteId: selectedSite?.id,
        CompanyId: isCompanyOrManufacturer ? id : 0,
        ProductId: showMapmodal?.from === "product-detail" ? id : 0
      };

      const response = await Postrequestcall(
        FETCH_SITES_BY_COMPANY_AND_PRODUCT,
        payload,
        loginData?.accessToken
      );

      const siteData = response?.data?.data[0];
      const sitePresence = isCompanyOrManufacturer
        ? siteData?.siteCompanyPresent
        : siteData?.siteProductPresent;

      setIsSiteIsPresent(sitePresence ?? false);
    } catch (error) {
      console.error("FETCH_SITES_BY_COMPANY_AND_PRODUCT ERROR:", error);
    }
  };

  useEffect(() => {
    if (updateSiteprojects === true) {
      getSiteImages();
      dispatch(setSiteprojects(false));
      if (props?.showDropMarkerOnMap || selectedSite?.name === "") {
        if (props?.showDropMarkerOnMap) {
          props?.onClose(); // After Add Project if Dropped pinned open then close the Dropped pin
        }
        props.getSitesofCurrentlocation(selectedSite?.latitude, selectedSite?.longitude, ""); // After add project call the function for showing the current site marker on map
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateSiteprojects]);

  useEffect(() => {
    if (selectLocation?.from === "site-detail" && selectLocation?.open === false) {
      Savesitewithlocation();
      let getCurrentLocation = {
        open: false,
        lat: 0,
        lng: 0,
        from: ""
      };
      dispatch(setSelectlocation(getCurrentLocation));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectLocation]);

  const getSiteImages = async () => {
    try {
      if (selectedSite?.id) {
        const obj = {
          SiteId: selectedSite?.id,
          PageNumber: 1,
          NrRowsPerPage: 100
        };
        const res = await Postrequestcall(
          FETCH_SITES_PROJECTS_PICTURES,
          obj,
          loginData?.accessToken
        );
        if (res?.data?.status === true && res?.data?.message === "OK") {
          const sortedPictures = (res?.data?.data || []).sort((a, b) => a.pictureId - b.pictureId);
          setProjectImageArray(sortedPictures);
        }
      }
    } catch (err) {
      console.log("getSiteImages-> Error When Fetching Site Project Pictures: ", err);
    }
  };

  const getSiteDescriptions = async (descPageNumber) => {
    try {
      const obj = {
        PageNr: descPageNumber,
        NrOfRecPerPage: 10,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: false,
        SearchList: [{ siteId: selectedSite?.id }],
        SortList: [
          {
            FieldName: "Id",
            Direction: "DESC"
          }
        ]
      };
      let siteDescriptionsRes = await Postrequestcall(
        FETCH_SITES_DESCRIPTIONS,
        obj,
        loginData?.accessToken
      );
      if (siteDescriptionsRes?.status === 200) {
        setDesnum(Number(siteDescriptionsRes?.data?.nrOfRecords - 1));
        setSiteDescriptions(siteDescriptionsRes?.data?.data);
      }
    } catch (error) {
      console.log("getSiteDescriptions-> Error While Fetching Site Description: ", error);
    }
  };

  const isImageUrlValid = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true); // Image loaded successfully
      img.onerror = () => resolve(false); // Failed to load (404, etc.)
      img.src = url;
    });
  };

  const openImageModal = async (item, index) => {
    const isValid = await isImageUrlValid(item?.pictureUrl);
    if (isValid) {
      setPictureViewerOpen(true);
      setPictureViewIndex(index);
    } else {
      alert("No Image");
    }
  };

  const openImageSeeMoreModal = () => {
    setImageModalOpen(true);
  };

  const truncateText = (text, maxLength) => {
    if (text?.length <= maxLength) {
      return text;
    }
    return text?.substring(0, maxLength) + " ...";
  };

  const handleShowMoreDescriptions = () => {
    setInitialViewMore(false);
  };

  const onClose = () => {
    props.onClose();
  };

  const openAddDescriptionDialog = () => {
    setMoreMenuAnchorEl(false);
    setAddDescriptionDialogOpen(true);
  };

  // set site active status
  const setSiteActiveStatus = async () => {
    try {
      let payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: siteInfo?.id
          }
        ]
      };
      let getResponse = await Postrequestcall(SITE_ACTIVE, payload, loginData?.accessToken);
      if (getResponse.status === 201) {
        await getSiteInfo();
      }
      setMoreMenuAnchorEl(false);
    } catch (error) {
      setMoreMenuAnchorEl(false);
      console.log("setSiteActiveStatus-> Error When Making Site Active: ", error);
    } finally {
    }
  };

  // Set Add Location
  const onAddLocation = () => {
    try {
      let getCurrentLocation = {
        open: true,
        lat: 0,
        lng: 0,
        from: "site-detail"
      };
      dispatch(setSelectlocation(getCurrentLocation));
      setMoreMenuAnchorEl(false);
    } catch (error) {
    } finally {
    }
  };

  // Save site location
  const Savesitewithlocation = async () => {
    try {
      setLoading(true);
      const getLocation = await getAddress({
        lat: selectLocation.lat,
        lng: selectLocation.lng
      });
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: siteInfo?.id,
            Name: siteInfo?.name,
            Address: getLocation?.objAddress?.address,
            City: getLocation?.objAddress?.city,
            Province: getLocation?.objAddress?.province,
            PostalCode: getLocation?.objAddress?.postalCode,
            Country: getLocation?.objAddress?.country,
            Latitude: getLocation?.objAddress?.lat ?? 0,
            Longitude: getLocation?.objAddress?.lng ?? 0,
            StartDate: "",
            EndDate: "",
            Active: siteInfo?.active,
            RecordStatusId: 1,
            ContractorId: 0,
            JobNo: "",
            ConstructionStatusId: 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(SAVE_SITES, getObject, loginData?.accessToken);
      if (getResponse.status === 201) {
        if (props?.filterFlag) {
          // for update no location count when sitetypes open
          const getResponse = await Getrequestcall(
            SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
            loginData?.accessToken
          );
          if (getResponse.status === 200) {
            dispatch(setNoLocationSites(getResponse.data?.data ?? []));
            dispatch(setNolocationcount(getResponse.data?.data?.length));
          }
        }
        await getSiteInfo();
      }
    } catch (error) {
      console.log("Savesitewithlocation-> Error When Saving Site: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSite = async (from, siteId, detailsPageId) => {
    switch (from) {
      case "company-detail":
      case "manufacture-detail":
        try {
          const payload = [
            {
              Id: 0,
              SiteId: siteId,
              CompanyId: detailsPageId,
              ModifiedBy: Number(loginData?.userInformation?.UserId)
            }
          ];
          const res = await Postrequestcall(SAVE_SITE_COMPANIES, payload, loginData?.accessToken);
          if (res.status === 201) {
            const mapModal = {
              open: false,
              from: "",
              select: "reload-site-list"
            };
            dispatch(setShowmapmodal(mapModal));
          }
        } catch (error) {
          console.log("saveSiteFromDetailpage-> Error While Saving Site from Detail page: ", error);
        }

        break;
      case "product-detail":
        try {
          const obj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                SiteId: siteId,
                ProductId: detailsPageId,
                RecordStatusId: 1,
                ModifiedBy: loginData?.userInformation?.UserId
              }
            ]
          };
          const res = await Postrequestcall(SAVE_SITE_PRODUCTS, obj, loginData?.accessToken);
          if (res.status === 201) {
            const mapModal = {
              open: false,
              from: "",
              select: "reload-site-list"
            };
            dispatch(setShowmapmodal(mapModal));
          }
        } catch (error) {
          console.log("saveSiteFromDetailpage-> Error While Saving Site from Detail page: ", error);
        }
        break;
      default:
        break;
    }
  };

  const getDetailPageName = () => {
    switch (showMapmodal?.from) {
      case "company-detail":
        return "Company";
      case "manufacture-detail":
        return "Manufacturer";
      case "product-detail":
        return "Product";
      default:
        return "";
    }
  };

  // Delete site pop up open
  const onDeletesite = () => {
    setDeleteSiteConfirmModalOpen(true);
    setMoreMenuAnchorEl(false);
  };

  // Delete site with site id
  const handleDeleteSite = async () => {
    try {
      const payloadObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: siteInfo?.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getDeleteresponse = await Postrequestcall(
        DELETE_SITES,
        payloadObj,
        loginData?.accessToken
      );

      if (getDeleteresponse.status === 201) {
        setDeleteSiteConfirmModalOpen(false);
        props.onClose();
        await props.getNolocationsites();
        const getResponse = await Getrequestcall(
          SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
          loginData?.accessToken
        );
        if (getResponse.status === 200) {
          if (getResponse.data?.data?.length >= 0) {
            dispatch(setNoLocationSites(getResponse.data?.data ?? []));
            dispatch(setNolocationcount(getResponse.data?.data?.length));
          }
        }
      } else {
        setDeleteSiteConfirmModalOpen(false);
        props.onClose();
        await props.getNolocationsites();
      }
    } catch (err) {
      props.onClose();
      await props.getNolocationsites();
      setDeleteSiteConfirmModalOpen(false);
      console.log("handleDeleteSite-> Error When Trying To Delete Site: ", err);
    }
  };

  // Site report
  const openSiteReport = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.site?.name,
      AppScreenId: Pages?.site?.id,
      recordId: siteInfo?.id ?? 0
    };
    dispatch(setShowReport(reportObj));
    setMoreMenuAnchorEl(false);
  };

  const openAddProject = () => {
    if (selectedSite?.name === "") {
      setSkipEffect(true);
      dispatch(setSelectedsite(siteInfo));
    }
    dispatch(setProjectimages([]));
    dispatch(setSiteprojects(false));
    dispatch(setShowaddproject(true));
    if (props.showDropMarkerOnMap) {
      let selectedSite = {
        // If site detail have dropped pinned
        id: 0,
        name: "",
        latitude: props?.chooseLocation?.lat,
        longitude: props?.chooseLocation?.lng
      };
      dispatch(setSelectedsite(selectedSite));
    }
  };

  const onChoosesite = () => {
    dispatch(setChoosesite(siteInfo)); // store current site information
    dispatch(setSelectedsite(siteInfo)); // store current site information
    let mapModal = {
      open: false,
      from: showMapmodal?.from,
      select: validValues.includes(showMapmodal?.from) ? "project" : ""
    };
    dispatch(setShowmapmodal(mapModal)); // Close map modal
  };

  const openAddsite = () => {
    let locationModal = {
      open: false,
      lat: props?.chooseLocation?.lat,
      lng: props?.chooseLocation?.lng
    };
    dispatch(setSelectlocation(locationModal));
    dispatch(setSelectedsite(null));
    props.setShowaddsite(true);
  };

  const onChooselocation = () => {
    let getCurrentLocation = {
      open: true,
      lat: 0,
      lng: 0,
      from: "site-detail"
    };
    dispatch(setSelectlocation(getCurrentLocation));
  };

  const SavesitewithName = async (name) => {
    try {
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: siteInfo?.id,
            Name: name,
            Address: siteInfo?.address,
            City: siteInfo?.city,
            Province: siteInfo?.province,
            PostalCode: siteInfo?.postalCode,
            Country: siteInfo?.country,
            Latitude: siteInfo?.latitude ?? 0,
            Longitude: siteInfo?.longitude ?? 0,
            StartDate: "",
            EndDate: "",
            Active: siteInfo?.active,
            RecordStatusId: 1,
            ContractorId: 0,
            JobNo: "",
            ConstructionStatusId: 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(SAVE_SITES, getObject, loginData?.accessToken);
      if (getResponse.status === 201) {
        if (props.filterFlag === true) {
          await getSiteInfo();
          await props.onFilterClick("Unnamed");
        } else {
          await getSiteInfo();
        }
      }
    } catch (error) {
      console.log("SavesitewithName-> Error When Trying TO Save Site: ", error);
    } finally {
    }
  };

  const handleTabChange = async (event, newTab) => {
    console.log("newTab", newTab);
    if (activeTab !== newTab) {
      setActiveTab(newTab);
    }
  };

  const handleSiteImageSelect = async (event) => {
    try {
      setLoading(true);
      const files = Array.from(event.target.files);
      if (!files.length) {
        setLoading(false);
        return;
      }
      const userId = Number(loginData?.userInformation?.UserId);
      const siteId = selectedSite?.id ?? 0;
      const obj = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: false,
        SaveList: [
          {
            Id: 0,
            FormatTypeId: 1,
            PostedByUserId: userId,
            AppId: 2,
            AppRecordId: siteId,
            Message: "<<<picture>>>",
            ModifiedBy: userId
          }
        ]
      };
      const postRes = await Postrequestcall(SAVE_POSTS, obj, loginData?.accessToken);
      const postId = postRes?.data?.data?.[0]?.objData?.id;
      if (!postId) throw new Error("Post ID not returned from SAVE_POSTS");
      // Concurrent image uploads using Promise.all
      await Promise.all(
        files.map((file) => {
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("PostId", postId);
          formData.append("ModifiedBy", userId);
          formData.append("Pictures", file);
          return Fileuploadrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken);
        })
      );
      await getSiteImages();
    } catch (error) {
      console.error("handleSiteImageSelect-> Error When Saving Site Picture: ", error);
    } finally {
      setLoading(false);
    }
  };

  const getFullUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };

  return (
    <>
      {addDescriptionDialogOpen && (
        <AddDescription
          getSiteDescriptions={getSiteDescriptions}
          handleClose={() => {
            setAddDescriptionDialogOpen(false);
          }}
          addDescriptionDialogOpen={addDescriptionDialogOpen}
        />
      )}

      {addSiteWebsiteModalOpen && (
        <AddWebsiteModal
          open={addSiteWebsiteModalOpen}
          onClose={() => {
            setAddSiteWebsiteModalOpen(false);
          }}
          from="SiteCard"
          data={siteInfo || {}}
          onDataSave={getSiteInfo}
          onSaveClick={() => {}}
        />
      )}

      {otherDescriptionDialogOpen && (
        <Sitedescriptions
          otherDescriptionDialogOpen={otherDescriptionDialogOpen}
          handleClose={() => setOtherDescriptionDialogOpen(false)}
        />
      )}

      <PromptModal
        isOpen={deleteSiteConfirmModalOpen}
        onClose={() => {
          setMoreMenuAnchorEl(false);
          setDeleteSiteConfirmModalOpen(false);
        }}
        title={TEXT_DELETE_SITE_ALERT}
        desc={TEXT_DELETE_SITE_DESC_ALERT}
        redButtonText={BUTTON_DELETE}
        onRedButtonClick={() => {
          handleDeleteSite();
        }}
      />

      {showAddNameModal && (
        <Addsitename
          showAddNameModal={showAddNameModal}
          siteInfo={siteInfo}
          setSiteInfo={setSiteInfo}
          SavesitewithName={SavesitewithName}
          handleClose={() => setShowAddNameModal(false)}
        />
      )}

      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          pictures={projectImageArray?.slice(0, 5)?.map((pic) => ({
            src: pic.pictureUrl,
            alt: ""
          }))}
          viewerIndex={pictureViewIndex}
        />
      )}

      {imageModalOpen && (
        <SiteImages
          imageModalOpen={imageModalOpen}
          setImageModalOpen={setImageModalOpen}
          selectedSite={selectedSite}
        />
      )}

      <input
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleSiteImageSelect}
      />
      {(props.from === "page" || showMapmodal?.select === "add-site") &&
      props.showDropMarkerOnMap ? (
        <Card className="main-Site-content-card" sx={{ p: 0, borderRadius: 0 }}>
          <Card sx={{ p: 2, width: "400px" }}>
            <Stack sx={{ display: "flex", pb: 1,  pl: 0.5,  justifyContent: "space-between" }} direction={"row"}>
              <Stack sx={{ display: "flex", justifyContent: "flex-start" }}>
                <Typography variant="h6"> {TEXT_DROPPED_PIN}</Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {props?.siteAddressData?.address !== "" ? props?.siteAddressData?.address : null}
                </Typography>
              </Stack>
              <Stack>
                <IconButton
                  size="small"
                  style={{ color: "white", backgroundColor: "lightgrey" }}
                  onClick={onClose}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Stack>
            </Stack>
            <Stack spacing={1.5}>
              <Stack>
                <Button fullWidth variant="contained" color="primary" onClick={() => openAddsite()}>
                  {TEXT_ADD_NEW_SITE}
                </Button>
              </Stack>
              <Divider />
              <Stack sx={{ display: "flex", alignItems: "center" }} direction={"column"}>
                <Typography variant="body2" sx={{ color: "GrayText" }}>
                  {TEXT_NO_PROJECTS_AT_LOCATION}
                </Typography>
                <Button variant="text" color="primary" onClick={() => openAddProject()}>
                  {TEXT_ADD_PROJECT_CAPS}
                </Button>
              </Stack>
            </Stack>
          </Card>
        </Card>
      ) : loading ? (
        <>
          <Card
            className="main-Site-content-card"
            sx={{
              width: isSmallScreen ? "100%" : !props.siteTypes ? "400px" : "430px",
              left: isMediumScreen ? "0px" : !props.siteTypes ? "0px" : "400px",
              position: "absolute",
              borderRadius: !props.siteTypes ? "0px" : "16px",
              padding: isSmallScreen ? "0px" : !props.siteTypes ? "0px" : "15px"
            }}>
            <Card sx={{ p: 1, width: "100%" }}>
              {/* Title and Address */}
              <Stack spacing={1} sx={{ mb: 2 }}>
                <Skeleton variant="text" width="90%" height={32} />
              </Stack>
              {/* Chip/Status */}
              <Skeleton variant="rounded" width={80} height={32} sx={{ mb: 2 }} />
              {/* Tabs */}
              <Stack sx={{ mb: 2, justifyContent: "space-between" }} direction="row" spacing={2}>
                <Skeleton variant="rounded" width={120} height={32} />
                <Skeleton variant="rounded" width={120} height={32} />
                <Skeleton variant="rounded" width={120} height={32} />
              </Stack>
              {/* Description */}
              <Skeleton variant="text" width="90%" height={24} sx={{ mb: 1 }} />
              {/* Company List Skeleton INSIDE the card */}
              <CompanyListSkeleton />
              {/* Action Buttons (if any) */}
            </Card>
          </Card>
        </>
      ) : (
        <>
          <Menu
            transformOrigin={{ horizontal: "center", vertical: "top" }}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            style={{ top: "0px", left: "10px" }}
            anchorEl={moreMenuAnchorEl}
            open={Boolean(moreMenuAnchorEl)}
            onClose={(event) => {
              setMoreMenuAnchorEl(false);
            }}>
            {siteInfo?.active ? null : (
              <MenuItem
                onClick={() => {
                  setSiteActiveStatus();
                }}
                style={{ color: BIBlue }}
                dense>
                {TEXT_FLAG_ACTIVE}
              </MenuItem>
            )}
            {siteInfo?.latitude === 0 && siteInfo?.longitude === 0 ? (
              <MenuItem style={{ color: BIBlue }} dense onClick={() => onAddLocation()}>
                {TEXT_ADD_LOCATION}
              </MenuItem>
            ) : null}

            {(siteInfo?.address !== "" ||
              siteInfo?.latitude !== 0 ||
              siteInfo?.longitude !== 0) && (
              <MenuItem
                style={{ color: BIBlue }}
                dense
                onClick={() => {
                  fileInputRef.current.click();
                  setMoreMenuAnchorEl(false);
                }}>
                {TEXT_ADD_PICTURE}
              </MenuItem>
            )}

            <MenuItem
              style={{ color: BIBlue }}
              dense
              onClick={() => {
                setAddDescriptionDialogOpen(true);
                setMoreMenuAnchorEl(false);
              }}>
              {TEXT_ADD_DESCRIPTION}
            </MenuItem>

            {isSiteInfoIncomplete && (
              <MenuItem
                style={{ color: BIBlue }}
                dense
                onClick={() => {
                  setAddSiteWebsiteModalOpen(true);
                  setMoreMenuAnchorEl(false);
                }}>
                {BUTTON_ADD_WEBSITE}
              </MenuItem>
            )}

            {siteInfo?.latitude === 0 && siteInfo?.longitude === 0 ? (
              <MenuItem style={{ color: BIRed }} dense onClick={() => onDeletesite()}>
                {TEXT_DELETE_SITE}
              </MenuItem>
            ) : null}
            <MenuItem style={{ color: BIRed }} dense onClick={() => openSiteReport()}>
              {TEXT_REPORT}
            </MenuItem>
          </Menu>
          {props.showSitedetail ? (
            <Card
              className="main-Site-content-card"
              sx={{
                width: isSmallScreen ? "100%" : !props.siteTypes ? "400px" : "430px",
                left: isMediumScreen ? "0px" : !props.siteTypes ? "0px" : "400px",
                position: "absolute",
                borderRadius: !props.siteTypes ? "0px" : "16px",
                padding: isSmallScreen ? "0px" : !props.siteTypes ? "0px" : "15px"
              }}>
              <Card className="main-content-card" sx={{ p: 1, m: 0, width: "100%" }}>
                <Stack sx={{ display: "flex", justifyContent: "space-between" }} direction={"row"}>
                  <Stack sx={{ display: "flex", justifyContent: "flex-start" }} spacing={0.5}>
                    <Typography
                      variant="h6"
                      sx={{ color: siteInfo?.name?.trim() !== "" ? "textPrimary" : "textSecondary" }}>
                      {siteInfo?.name?.trim() !== "" ? siteInfo?.name : TEXT_UNNAMED_SITE}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      {siteInfo?.address !== ""
                        ? siteInfo?.address:null
                        // TEXT_NO_LOCATION
                      }
                    </Typography>
                  </Stack>
                  <Stack sx={{ gap: 1,  display: "flex", alignItems: "flex-start"  }} direction={"row"} >
                    {validValues.includes(showMapmodal?.from) || props?.from === "quiz" ? (
                      <></>
                    ) : (
                      <Stack>
                        <IconButton
                          size="small"
                          onClick={(event) => {
                            setMoreMenuAnchorEl(event.currentTarget);
                          }}>
                          <MoreHorizIcon />
                        </IconButton>
                      </Stack>
                    )}
                    <Stack>
                      <IconButton
                        size="small"
                        style={{ color: "white", backgroundColor: "lightgrey" }}
                        onClick={onClose}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </Stack>
                </Stack>
                <Box className="main-content-card-list" id={scrollTargetId} sx={{ mt: 1 }}>
                  <>
                    <Stack spacing={1}>
                      {validValues.includes(showMapmodal?.from) ? null : (
                        <>
                          {siteInfo?.latitude === 0 && siteInfo?.longitude === 0 ? (
                            <Stack sx={{ display: "flex",  p: 2, alignItems: "flex-start" }}  backgroundColor={BILightRed} borderRadius={"5px"} spacing={0.5}>
                              <Stack sx={{ display: "flex", alignItems: "center" }} direction={"row"}>
                                <ErrorIcon fontSize="small" color="secondary" />
                                <Typography sx={{ color: "secondary",  pl: 1, fontWeight: "bold" }} variant="body2" >
                                  {TEXT_SITE_NOT_VISIBLE_MESSAGE}
                                </Typography>
                              </Stack>
                              <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => onChooselocation()}>
                                {TEXT_ADD_SITE_LOCATION}
                              </Button>
                            </Stack>
                          ) : null}
                        </>
                      )}

                      {validValues.includes(showMapmodal?.from) ? null : (
                        <>
                          {siteInfo?.name?.trim() === "" ? (
                            <Stack sx={{ display: "flex",  p: 2, alignItems: "flex-start" }}  backgroundColor={BILightYellow} borderRadius={"5px"} spacing={0.5}>
                              <Stack sx={{ display: "flex", alignItems: "center" }} direction={"row"}>
                                <WarningIcon fontSize="small" sx={{ color: BIYellow }} />
                                <Typography sx={{ color: BIYellow,  pl: 1, fontWeight: "bold" }} variant="body2" >
                                  {TEXT_ADD_SITE_NAME_STATEMENT}
                                </Typography>
                              </Stack>
                              <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => setShowAddNameModal(true)}>
                                {TEXT_ADD_SITE_NAME_CAPS}
                              </Button>
                            </Stack>
                          ) : null}
                        </>
                      )}
                      <Stack sx={{ alignItems: "center", rowGap: 1 }} direction="row" spacing={1} flexWrap="wrap">
                        {siteInfo?.active && (
                          <Chip style={{ width: "100px" }} label={TEXT_ACTIVE_SITE} />
                        )}
                        {siteInfo?.nrOfCompanies > 0 && (
                          <Chip 
                            label={`${siteInfo?.nrOfCompanies} Companies`} 
                            onClick={() => setActiveTab("companies")}
                          />
                        )}
                        {siteInfo?.nrOfProjects > 0 && (
                          <Chip 
                            label={`${siteInfo?.nrOfProjects} Projects`} 
                            onClick={() => setActiveTab("projects")}
                          />
                        )}
                        {siteInfo?.nrOfProducts > 0 && (
                          <Chip 
                            label={`${siteInfo?.nrOfProducts} Products`} 
                            onClick={() => setActiveTab("products")}
                          />
                        )}
                      </Stack>

                      {projectImageArray?.length > 0 && (
                        <Box sx={{ display: "flex", position: "relative", width: "100%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              overflowX: "auto",
                              gap: 1,
                              scrollbarWidth: "thin",
                              "&::-webkit-scrollbar": {
                                height: "6px"
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1"
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "3px"
                              },
                              flex: 1,
                              mr: projectImageArray?.length > 5 ? "100px" : 0
                            }}>
                            {projectImageArray?.slice(0, 5).map((item, index) => (
                              <Box
                                key={index}
                                onClick={() => openImageModal(item, index)}
                                sx={{
                                  flexShrink: 0,
                                  width: "150px"
                                }}>
                                <img
                                  src={item?.pictureUrl}
                                  alt={"Project"}
                                  style={{
                                    width: "150px",
                                    height: "85px",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                    borderRadius: "5px"
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = PlaceholderImg;
                                  }}
                                />
                              </Box>
                            ))}
                          </Box>
                          {projectImageArray?.length > 5 && (
                            <Box
                              sx={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                width: "90px",
                                height: "85px",
                                display: "flex",
                                background:
                                  "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 20%, rgba(255,255,255,1) 100%)"
                              }}>
                              <Button
                                color="primary"
                                size="small"
                                variant="outlined"
                                sx={{
                                  width: "90px",
                                  height: "85px",
                                  ml: "auto"
                                }}
                                onClick={() => openImageSeeMoreModal()}>
                                <div>
                                  <ArrowForwardIcon />
                                  <br />
                                  {DESCRIPTION_SEE_MORE}
                                </div>
                              </Button>
                            </Box>
                          )}
                        </Box>
                      )}
                      <>
                        {siteDescriptions?.length > 0 ? (
                          <>
                            {siteDescriptions[0]?.description?.length > 50 ? (
                              <>
                                {initialViewMore ? (
                                  <>
                                    <Typography variant="body2" className="site-description">
                                      {" "}
                                      {truncateText(siteDescriptions[0]?.description, 195)}
                                    </Typography>
                                    <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
                                      <Button
                                        variant="text"
                                        size="small"
                                        color="primary"
                                        onClick={handleShowMoreDescriptions}>
                                        {DESCRIPTION_SEE_MORE}
                                      </Button>
                                    </Stack>
                                  </>
                                ) : (
                                  <Typography variant="body2" style={{ wordBreak: "break-all" }}>
                                    {" "}
                                    {siteDescriptions[0]?.description}
                                  </Typography>
                                )}
                              </>
                            ) : (
                              <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                                {" "}
                                {siteDescriptions[0]?.description}
                              </Typography>
                            )}
                          </>
                        ) : (
                          <>
                            {validValues.includes(showMapmodal?.from) ||
                            props?.from === "quiz" ? null : (
                              <>
                                {desNum === 0 && (
                                  <Stack>
                                    <Button
                                      fullWidth
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => openAddDescriptionDialog()}>
                                      {TEXT_ADD_DESCRIPTION_CAPS}
                                    </Button>
                                  </Stack>
                                )}
                              </>
                            )}
                          </>
                        )}
                        {desNum >= 1 && (
                          <Stack sx={{ display: "flex", alignItems: "flex-end" }}>
                            <Typography
                              variant="body2"
                              style={{
                                color: "gray",
                                cursor: "pointer"
                              }}
                              onClick={() => setOtherDescriptionDialogOpen(true)}>
                              {TEXT_OTHERS_DESCRIPTIOJN} {desNum}
                            </Typography>
                          </Stack>
                        )}
                      </>
                    </Stack>

                    {siteInfo?.website && (
                      <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
                        <Public fontSize="small" style={{ color: BIBlue }} />
                        <a
                          href={getFullUrl(siteInfo.website)}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "none", color: BIBlue }}>
                          <Typography style={{ color: BIBlue }}>{siteInfo?.website}</Typography>
                        </a>
                      </Stack>
                    )}

                    {showMapmodal?.select !== "add-site" && (
                      <Box
                        sx={{
                          position: "sticky",
                          top: 0,
                          zIndex: 10,
                          background: "#fff",
                          borderBottom: "1px solid #eee",
                          mb: 1
                        }}>
                        <Tabs
                          sx={{
                            minHeight: "15px",
                            marginTop: 0,
                            pl: 0,
                            "& .MuiTabs-scrollButtons": {
                              width: "auto"
                            }
                          }}
                          textColor="primary"
                          indicatorColor="primary"
                          scrollButtons="auto"
                          value={activeTab}
                          onChange={handleTabChange}
                          variant="scrollable">
                          {tabsOptions.map((tab, index) => (
                            <Tab
                              sx={{ textTransform: "none" }}
                              key={index}
                              value={tab.name}
                              label={tab.value}
                            />
                          ))}
                        </Tabs>
                      </Box>
                    )}
                    {showMapmodal?.from === "earn-rewards" && showMapmodal?.select === "project" ? (
                      <></>
                    ) : showMapmodal?.select === "add-site" ? (
                      <>
                        {isSitePresent ? (
                          <div
                            style={{
                              background: BILightGreen,
                              color: BIGreen,
                              display: "flex",
                              flexDirection: "column",
                              padding: "10px",
                              borderRadius: "10px",
                              marginTop: "10px",
                              justifyContent: "center",
                              alignItems: "center"
                            }}>
                            <CheckCircle />
                            <Typography sx={{ mt: "5px" }}>
                              This site is already added to the {getDetailPageName()}.
                            </Typography>
                          </div>
                        ) : (
                          <Button
                            fullWidth
                            variant="contained"
                            style={{ background: BIBlue, marginTop: "10px" }}
                            onClick={() => handleAddSite(showMapmodal?.from, selectedSite?.id, id)}>
                            Add Site to {getDetailPageName()}
                          </Button>
                        )}
                      </>
                    ) : (
                      <>
                        {activeTab === "companies" && showMapmodal?.select !== "add-site" && (
                          <SitesCompanySection
                            activeTab={activeTab}
                            siteId={siteInfo?.id}
                            scrollId={scrollTargetId}
                          />
                        )}
                        {activeTab === "products" && showMapmodal?.select !== "add-site" && (
                          <SitesProductSection
                            activeTab={activeTab}
                            siteId={siteInfo?.id}
                            scrollId={scrollTargetId}
                          />
                        )}
                      </>
                    )}
                    {activeTab === "projects" && showMapmodal?.select !== "add-site" && (
                      <SitesProjectSection
                        activeTab={activeTab}
                        siteId={siteInfo?.id}
                        scrollId={scrollTargetId}
                        siteInfo={siteInfo}
                        openAddProject={openAddProject}
                      />
                    )}
                    {activeTab === "job-postings" && showMapmodal?.select !== "add-site" && (
                      <SitesJobPostSection
                        siteId={siteInfo?.id}
                        siteInfo={siteInfo}
                        activeTab={activeTab}
                      />
                    )}
                    {activeTab === "buy-sell" && showMapmodal?.select !== "add-site" && (
                      <SitesBuySellSection siteId={siteInfo?.id} activeTab={activeTab} />
                    )}
                    {activeTab === "services" && showMapmodal?.select !== "add-site" && (
                      <SitesServicesSection siteInfo={siteInfo} activeTab={activeTab} />
                    )}
                  </>
                </Box>
              </Card>
            </Card>
          ) : (
            <Card
              className="main-Site-content-card"
              sx={{
                width: isSmallScreen ? "100%" : !props.siteTypes ? "400px" : "430px",
                left: isMediumScreen ? "0px" : !props.siteTypes ? "0px" : "400px",
                position: "absolute",
                borderRadius: !props.siteTypes ? "0px" : "16px",
                padding: isSmallScreen ? "0px" : !props.siteTypes ? "0px" : "15px"
              }}>
              <Card sx={{ p: 1, width: "100%" }}>
                <Stack sx={{ display: "flex", justifyContent: "space-between" }} direction={"row"}>
                  {props.showDropMarkerOnMap ? (
                    <>
                      <Stack sx={{ display: "flex", justifyContent: "flex-start" }}>
                        <Typography variant="h5">{TEXT_DROPPED_PIN}</Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          {props?.siteAddressData?.address !== "" ? props?.siteAddressData?.address : null}
                        </Typography>
                      </Stack>
                    </>
                  ) : (
                    <Stack sx={{ display: "flex", justifyContent: "flex-start" }}>
                      <Typography
                        variant="h5"
                        style={{
                          color: siteInfo?.name?.trim() !== "" ? "black" : "GrayText"
                        }}>
                        {siteInfo?.name?.trim() !== "" ? siteInfo?.name : TEXT_UNNAMED_SITE}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {siteInfo?.address !== "" ? (
                          siteInfo?.address
                        ) : (
                          <>
                            {/* {siteInfo?.latitude === 0 && siteInfo?.longitude === 0 ? null : (
                              <>{`(${siteInfo?.latitude} , ${siteInfo?.longitude})`}</>
                            )} */}
                          </>
                        )}
                      </Typography>
                    </Stack>
                  )}
                  <Stack>
                    <IconButton
                      onClick={onClose}
                      size="small"
                      style={{ color: "white", backgroundColor: "lightgrey" }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                </Stack>
                <Divider sx={{ pt: 1 }} />
                <Stack sx={{ pt: 1.5 }}>
                  {props.from === "modal" && props.showDropMarkerOnMap ? (
                    <>
                      <Stack sx={{ display: "flex", alignItems: "center" }} direction={"column"}>
                        <Typography variant="body2" sx={{ color: "GrayText" }}>
                          {TEXT_NO_PROJECTS_AT_LOCATION}
                        </Typography>
                        <Button variant="text" color="primary" onClick={() => openAddProject()}>
                          {TEXT_ADD_PROJECT_CAPS}
                        </Button>
                      </Stack>
                    </>
                  ) : (
                    <Button
                      color="primary"
                      variant="contained"
                      fullWidth
                      onClick={(e) => onChoosesite(e)}>
                      {TEXT_CHOOSE}
                    </Button>
                  )}
                </Stack>
              </Card>
            </Card>
          )}
        </>
      )}
    </>
  );
};

export default SiteCard;

